import mapValues from "lodash-es/mapValues";

enum PATHS {
  CDN_IMAGES = "CDN/images",
  CITY_AUTOCOMPLETE = "API/hotel/api/v2/search-text",
  CITY_SEARCH = "API/hotel/api/v2/search-city",
  CITY_GET = "API/hotel/api/v2/search/cities/{cityTitle}",
  CITY_FILTERS = "HAPI/hotel/api/v2/cities/{cityId}/filters",
  CITY_CATEGORIES_GET = "SCALA/api/v1/category/search",
  CITY_SUGGESTION_GET = "API/hotel/promotion/v2/suggestions/cities/{cityTitle}",
  HOTEL_GEO_NEAREST = "HAPI/geo/v1/nearest",
  HOTEL_INFO = "API/hotel/api/v2/hotels/slug/{cityTitle}/{hotelTitle}",
  HOTEL_ROOMS = "API/hotel/api/v2/hotels/{hotelId}/rooms",
  HOTEL_PRICE_RANGE = "API/hotel/api/v2/hotels/{hotelId}/price-range",
  HOTEL_RATE = "HAPI/hotel/review/v2/ratings/{hotelId}",
  HOTEL_REVIEW = "HAPI/hotel/review/v2/reviews/{hotelId}",
  HOTEL_REVIEW_USEFULNESS = "HAPI/hotel/review/v2/reviews/{reviewId}/helpful",
  GET_HOTEL_BADGES = "SCALA/hotel/badge/v2",
  CREATE_BOOK = "SCALA/api/v1/shopping/create-book",
  GET_ROOM_CALENDAR = "GATEWAY/hotel/api/v2/hotels/{hotelId}/calendar/{roomId}",
  HOTEL_SHOPPING = "SCALA/api/v1/shopping/{hotelId}",
  CONFIRM_INFO = "SCALA/api/v1/shopping/{shopId}/confirm-info",
  GET_BOOKING_STATE = "SCALA/booking/{shopId}/booking-state",
  GET_PAYMENT_GATEWAYS = "API/service2/hotelbooking/v2/pass/payments/list",
  GET_VOUCHER = "GATEWAY/voucher/v2/b2c/{phoneNumber}/{bookId}/?lang={lang}",
  GET_RECEIPT = "GATEWAY/voucher/v2/b2c/{phoneNumber}/{bookId}/receipt",
  GEO_CITY_ID = "HAPI/geo/v1/cities/{id}",
  GEO_FIND = "HAPI/geo/v1/find",
  VILLA_BANNER = "HAPI/villa/listing/search/availability/banner/{id}",
  APPLY_DISCOUNT = "SCALA/api/v1/payment/{bookId}/apply_discount",
  PAYMENT_TOKEN = "SCALA/api/v1/payment/{bookId}/payment_token",
  PAYMENT_TOKEN_AMENDMENT = "HAPI/api/fulfillment/payment/{bookId}/v2/payment_token",
  CATEGORY_LANDING = "SCALA/hotel/api/v2/landings/{categoryTitle}",
  GET_LAST_SECOND_HOTELS = "API/hotel/promotion/v2/cities/{cityTitle}",
  GET_EARLY_BIRDS_BADGES = "API/hotel/promotion/v2/cities/{cityTitle}/early-bird",
  INSTALMENT_WALLET = "GATEWAY/hotel/api/v2/instalment/wallet",
  GET_BANNERS = "PLATFORM/banners/banner/active",
  GET_CITY_PAGE_BANNERS = "PLATFORM/banners/v1/banner/active",
  GET_PASSENGERS = "PLATFORM/passengers/v1/passengers",
  VILLA_SEARCH_LOCATION = "HAPI/villa/listing/search/location/{locationType}/{cityTitle}",
  CDN_VILLA_IMAGES = "STORE/villa",
  ROOM_NOTIFY = "API/trip-notifier/v1/notify",
  REMOVE_ROOM_NOTIFY = "API/trip-notifier/v1/notify/remove",
  SEARCH_GEO = "API/hotel/api/v2/search-geo",
  GET_CANCELLATION_DETAILS = "HAPI/internal/cancellation/cancellations/{code}/inquiry",
  CREATE_CANCELLATION_REQUEST = "HAPI/internal/cancellation/cancellations",
  ACCEPT_CANCELLATION_REQUEST = "HAPI/internal/cancellation/cancellations/{code}/accept",
  REJECT_CANCELLATION_REQUEST = "HAPI/internal/cancellation/cancellations/{code}/reject"
}

export const ENDPOINTS = mapValues(PATHS, (url: string) =>
  url.replace(/^.+?(\/)/, (matched) => {
    const baseURLs = {
      API: process.env["NEXT_PUBLIC_BASE_URL_API"],
      SCALA: process.env["NEXT_PUBLIC_BASE_URL_SCALA"],
      PLATFORM: process.env["NEXT_PUBLIC_BASE_URL_PLATFORM"],
      HAPI: process.env["NEXT_PUBLIC_BASE_URL_HAPI"],
      GATEWAY: process.env["NEXT_PUBLIC_BASE_URL_GATEWAY"],
      STORE: process.env["NEXT_PUBLIC_BASE_URL_STORE"],
      CDN: process.env["NEXT_PUBLIC_BASE_URL_CDN"]
    };
    const baseURL = matched.replaceAll(/\/+/g, "") as keyof typeof baseURLs;
    return `${baseURLs[baseURL]}/`;
  })
) as unknown as typeof PATHS;
